import React, { useContext } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { useNavigate } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { SavedGiftCardsList } from '@thd-olt-component-react/saved-gift-cards-list';
import { getReCaptchaKey } from '../../../utils/general';
import { GiftCardList } from './gift-card-list';

export const GiftCardListV2: React.FC = () => {
  const navigate = useNavigate();
  const handleOnAdd = () => {
    navigate('/myaccount/payments/addgiftcard');
  };
  const { instance } = useContext(AppContext);
  const isB2B = instance?.customer?.type === 'b2b';
  const isSaveGiftCardToAccountB2bEnabled = !!useConfigService(
    'fs-prop:payments__enableSaveGiftCardToAccountB2b',
  );
  const isSaveGiftCardToAccountB2cEnabled = !!useConfigService(
    'fs-prop:payments__enableSaveGiftCardToAccountB2c',
  );
  const shouldShowSavedGiftCard = isB2B
    ? isSaveGiftCardToAccountB2bEnabled
    : isSaveGiftCardToAccountB2cEnabled;

  if (!shouldShowSavedGiftCard) {
    return <GiftCardList />;
  }

  return (
    <SavedGiftCardsList
      onAdd={handleOnAdd}
      isB2B={isB2B}
      reCaptchaKey={getReCaptchaKey()}
    />
  );
};
